import styled from "styled-components";
import {FlexContainerBox} from "../../../../../../../../themes/architecture/css-helpers/flex";

export const FooterContainerBox = styled(FlexContainerBox)`
    padding: 2px;
    width: 100%;
`